export enum UserTicketErrorEnum {
  USER_TICKET_DATE_PAST = "USER_TICKET_DATE_PAST",
  USER_TICKET_SOLD_OUT = "USER_TICKET_SOLD_OUT",
  USER_TICKET_CREATION_FAILED = "USER_TICKET_CREATION_FAILED",
  USER_TICKET_NOT_AVAILABLE = "USER_TICKET_NOT_AVAILABLE"
}
